import { type UseQueryResult, useQuery } from '@tanstack/react-query'
import { genericApi } from '~/api'
import { type AppstreamSession } from '~/hooks/useAppstreamSessionsQuery'

interface UtilizationParticipant {
  id: number
  first_name: string
  last_name: string
  email: string
  username: string
  appstream_sessions: AppstreamSession[]
  total_appstream_session_duration_in_seconds: number
  total_appstream_session_duration_in_minutes: number
  total_appstream_session_duration_in_hours: number
  total_appstream_session_duration_time_span: string
}

interface ParticipantSessionsResponse {
  data: UtilizationParticipant[]
  total_duration_in_hours: number
}

export const useParticipantSessionsQuery = (
  courseId: number,
  params: { region_code: string | null }
): UseQueryResult<ParticipantSessionsResponse> => {
  return useQuery({
    queryKey: ['course', courseId, 'participant-sessions', params],
    queryFn: async () => {
      const { data } = await genericApi.getCourseParticipantSessions(courseId, params)
      return data
    }
  })
}
